import { LocalizedLink } from "@/i18n/language";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import { img } from "@/lib/images";
import { usePriceMap } from "@/hooks/usePrices";

export default function VillaInfoPage() {
  const { t, i18n } = useTranslation();
  const isDe = i18n.language.startsWith("de");
  const { priceMap, money } = usePriceMap();

  const amenities = isDe
    ? [
        "Welcome Drink und gekühltes Handtuch",
        "Kostenloser WLAN-Internetzugang",
        "Kostenlose Laptop Nutzung",
        "Tägliches Frühstück",
        "Täglich kostenlos je 1 Flasche Mineralwasser",
        "kein Fernseher in den Zimmern",
        "Schöne Reisfeld-Umgebung",
        "Fitness Studio in der Nähe",
        "Massage (gegen Bezahlung)",
        "Mittagessen (2 Gänge) 6 € pro Person",
        "Abendessen (3 Gänge) 14 € pro Person (schmackhafte lokale Küche)",
        "2 Fahrräder und Helm zur kostenlosen Benutzung",
        "Auto mit Fahrer (gegen Bezahlung)",
        "Check-out: 12:00 · Check-in: 15:00 · (bei Verfügbarkeit jederzeit)",
      ]
    : [
        "Welcome drink and chilled towel",
        "Free Wi-Fi Internet access",
        "Free laptop use",
        "Daily breakfast",
        "Daily 1 free bottle of mineral water per person",
        "No TV in the rooms",
        "Beautiful rice field surroundings",
        "Fitness studio free to use nearby",
        "Massage (for a fee)",
        "Lunch (2 courses) 7.00 US$ per person",
        "Dinner (3 courses) 16.00 US$ per person (tasty local cuisine)",
        "2 bicycles and helmet for free use",
        "Car with driver (for a fee)",
        "Check-out: 12:00 · Check-in: 15:00 · (anytime subject to availability)",
      ];

  const pavilion = isDe
    ? [
        "37 m² überdachter Pavillon mit großem runden Esstisch für 8 Personen",
        "Bücherschrank mit guter Auswahl an Büchern in Deutsch und Englisch, einige Französische Bücher",
      ]
    : [
        "37 m² covered pavilion with large round dining table for 8 people",
        "Bookcase with a good selection of books in German and English, some French books",
      ];

  const garden = isDe
    ? [
        "Gartenbenutzung für alle Villa Gäste",
        "keine Einsicht vom Nachbargrundstück",
        "Pool 4 x 9 Meter, 1,5 Meter gleichbleibend tief, für Villa Frangipani und Villa Bougainvillea",
        "Pool 6 x 11 Meter, 1,7 Meter gleichbleibend tief, für Villa Hibiskus",
        "Pool Liegen mit Auflagen",
      ]
    : [
        "Garden use for all villa guests",
        "No view from neighboring property",
        "Pool 4 x 9 meters, 1.5 meters consistently deep, for Villa Frangipani and Villa Bougainvillea",
        "Pool 6 x 11 meters, 1.7 meters consistently deep, for Villa Hibiscus",
        "Pool loungers with cushions",
      ];

  const leisure = isDe
    ? [
        "Fahrradfahren",
        "Wandern",
        "Spazieren",
        "Sightseeing Touren",
        "Fotografieren",
        "Besichtigungen (Museum und Tempel)",
        "Marktbesuch",
      ]
    : [
        "Cycling",
        "Hiking",
        "Walking",
        "Sightseeing tours",
        "Photography",
        "Visits (museum and temple)",
        "Market visit",
      ];

  const services = isDe
    ? [
        "Geldautomat in der Nähe",
        "Kleine Geschäfte und lokaler Markt",
        "Wäscherei",
      ]
    : [
        "ATM nearby",
        "Small shops and local market",
        "Laundry",
      ];

  const sports = isDe
    ? [
        "Fitnesscenter in der Nähe",
        "Fahrradfahren (von der Villa aus)",
        "Reisfeldwanderung (von der Villa aus)",
        "Regenwaldwanderung (45 Minuten Fahrt)",
      ]
    : [
        "Fitness center nearby (free use)",
        "Cycling (from the villa)",
        "Rice field walk (from the villa)",
        "Rainforest walk (45 minutes drive)",
      ];

  const golf = isDe
    ? [
        "Bali Nirwana 18 Loch (30 Minuten Fahrt) zurzeit GESCHLOSSEN",
        "Bali Handara 18 Loch (45 Minuten Fahrt)",
        "Bali National Golf Club 18 Loch (90 Minuten Fahrt)",
        "New Kuta Golf 18 Loch (90 Minuten Fahrt)",
        "Bali Beach Golf 9 Loch (45 Minuten Fahrt)",
      ]
    : [
        "Bali Nirwana 18 holes (30 minutes drive) currently CLOSED",
        "Bali Handara 18 holes (45 minutes drive)",
        "Bali National Golf Club 18 holes (90 minutes drive)",
        "New Kuta Golf 18 holes (90 minutes drive)",
        "Bali Beach Golf 9 holes (45 minutes drive)",
      ];

  const adventure = isDe
    ? [
        "Bergsteigen (Gunung Batur 1717 meter & Gunung Agung 3142 meter)",
        "Rafting (Ayung River)",
        "Wellenreiten (in Canggu, 30 Minuten Fahrt)",
        "Baden im Meer (in Sanur, 45 Minuten Fahrt)",
        "Jet-Skifahren (in Sanur, 45 Minuten Fahrt)",
        "Tiefseefischen & Angeln (von Sanur aus, 45 Minuten Fahrt)",
        "Delfine beobachten (nur in Nordbali, ca. 90 Minuten Fahrt)",
        "Schnorcheln (nur in Nordbali, ca. 90 Minuten Fahrt)",
        "Tauchen (nur in Ost- und Nordbali, jeweils ca. 2 Stunden Fahrt)",
      ]
    : [
        "Mountain climbing (Gunung Batur 1717 meters & Gunung Agung 3142 meters)",
        "Rafting (Ayung River)",
        "Surfing (in Canggu, 30 minutes drive)",
        "Swimming in the sea (in Sanur, 45 minutes drive)",
        "Jet skiing (in Sanur, 45 minutes drive)",
        "Deep sea fishing & angling (from Sanur, 45 minutes drive)",
        "Dolphin watching (only in North Bali, approx. 90 minutes drive)",
        "Snorkeling (only in North Bali, approx. 90 minutes drive)",
        "Diving (only in East and North Bali, approx. 2 hours drive each)",
      ];

  const rent = isDe
    ? [
        `Villa Frangipani 2 Schlafzimmer, Villa Bougainvillea 1 Schlafzimmer = Total 6 Personen ${money(
          priceMap["villa_frangipani_2"] + priceMap["villa_bougainvillea_1"]
        )} pro Nacht inklusive Frühstück für 6 Personen`,
        `Villa Frangipani 2 Schlafzimmer, Villa Bougainvillea 1 Schlafzimmer, Villa Hibiskus 3 Schlafzimmer = Total 12 Personen ${money(
          priceMap["villa_gesamt"]
        )} pro Nacht inklusive Frühstück für 12 Personen`,
        `Villa Hibiskus 3 Schlafzimmer mit eigenem Badezimmer = Total 6 Personen ${money(
          priceMap["villa_hibiskus_3"]
        )} pro Nacht inklusive Frühstück für 6 Personen`,
      ]
    : [
        `Villa Frangipani 2 bedrooms, Villa Bougainvillea 1 bedroom = Total 6 persons ${money(
          priceMap["villa_frangipani_2"] + priceMap["villa_bougainvillea_1"]
        )} per night including breakfast for 6 persons`,
        `Villa Frangipani 2 bedrooms, Villa Bougainvillea 1 bedroom, Villa Hibiscus 3 bedrooms = Total 12 persons ${money(
          priceMap["villa_gesamt"]
        )} per night including breakfast for 12 persons`,
        `Villa Hibiscus 3 bedrooms with own bathroom = Total 6 persons ${money(
          priceMap["villa_hibiskus_3"]
        )} per night including breakfast for 6 persons`,
      ];

  const renderList = (items: string[], icon: string) => (
    <ul className="space-y-2">
      {items.map((item) => (
        <li
          key={item}
          className="flex items-start gap-2 text-sm text-foreground-700"
        >
          <i className={`${icon} text-accent-700 mt-0.5 flex-shrink-0`}></i>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <PageHeader
          eyebrow={t("villa_info_eyebrow")}
          title={t("villa_info_title")}
          subtitle={t("villa_info_subtitle")}
          image={img("villas/villa-info/header-villainfo-01.jpg")}
          imageAlt="Villa Kompiang"
        />

        <section className="py-12 md:py-16">
          <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main content */}
            <div className="lg:col-span-2 space-y-10">
              {/* Intro */}
              <div>
                <p className="text-foreground-700 leading-relaxed text-base whitespace-pre-line">
                  {t("villa_info_intro")}
                </p>
              </div>

              {/* Layout image */}
              <div className="rounded-lg overflow-hidden border border-background-200">
                <img
                  src={img("villas/villa-info/layout-villakompiang-01.png")}
                  alt={t("villa_info_layout_alt")}
                  className="w-full h-auto object-contain"
                />
              </div>

              {/* Amenities */}
              <div>
                <h2 className="font-heading text-lg text-foreground-950 mb-4 uppercase tracking-wider">
                  {t("villa_info_amenities_title")}
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {amenities.map((item) => (
                    <div
                      key={item}
                      className="flex items-start gap-2 text-sm text-foreground-700"
                    >
                      <i className="ri-circle-fill text-accent-700 mt-1.5 flex-shrink-0 text-[6px]"></i>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Pavilion */}
              <div>
                <h2 className="font-heading text-lg text-foreground-950 mb-4 uppercase tracking-wider">
                  {t("villa_info_pavilion_title")}
                </h2>
                {renderList(pavilion, "ri-check-line")}
              </div>

              {/* Garden */}
              <div>
                <h2 className="font-heading text-lg text-foreground-950 mb-4 uppercase tracking-wider">
                  {t("villa_info_garden_title")}
                </h2>
                {renderList(garden, "ri-check-line")}
              </div>

              {/* Leisure */}
              <div>
                <h2 className="font-heading text-lg text-foreground-950 mb-4 uppercase tracking-wider">
                  {t("villa_info_leisure_title")}
                </h2>
                {renderList(leisure, "ri-check-line")}
              </div>

              {/* Services */}
              <div>
                <h2 className="font-heading text-lg text-foreground-950 mb-4 uppercase tracking-wider">
                  {t("villa_info_services_title")}
                </h2>
                {renderList(services, "ri-check-line")}
              </div>

              {/* Sports */}
              <div>
                <h2 className="font-heading text-lg text-foreground-950 mb-4 uppercase tracking-wider">
                  {t("villa_info_sport_title")}
                </h2>
                {renderList(sports, "ri-check-line")}
              </div>

              {/* Golf */}
              <div>
                <h2 className="font-heading text-lg text-foreground-950 mb-4 uppercase tracking-wider">
                  {t("villa_info_golf_title")}
                </h2>
                <div className="space-y-2">
                  {golf.map((item) => (
                    <div
                      key={item}
                      className="flex items-start gap-2 text-sm text-foreground-700"
                    >
                      <i className="ri-circle-fill text-accent-700 mt-1.5 flex-shrink-0 text-[6px]"></i>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Adventure */}
              <div>{renderList(adventure, "ri-check-line")}</div>

              {/* Divider + Rent */}
              <div className="border-t border-background-200 pt-8">
                <h2 className="font-heading text-lg text-foreground-950 mb-4 uppercase tracking-wider">
                  {t("villa_info_rent_title")}
                </h2>
                <div className="space-y-3">
                  {rent.map((item) => (
                    <div
                      key={item}
                      className="flex items-start gap-2 text-sm text-foreground-700"
                    >
                      <i className="ri-circle-fill text-accent-700 mt-1.5 flex-shrink-0 text-[6px]"></i>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-24 space-y-6">
                {/* Villa Links */}
                <div className="bg-background-50 border border-background-200 rounded-lg p-6">
                  <h3 className="font-heading text-sm text-foreground-950 mb-4 uppercase tracking-wider">
                    {t("villa_info_sidebar_villas")}
                  </h3>
                  <div className="space-y-3">
                    <LocalizedLink
                      to="/villa-frangipani"
                      className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      Villa Frangipani
                    </LocalizedLink>
                    <LocalizedLink
                      to="/villa-bougainvillea"
                      className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      Villa Bougainvillea
                    </LocalizedLink>
                    <LocalizedLink
                      to="/villa-hibiscus"
                      className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      {isDe ? "Villa Hibiskus" : "Villa Hibiscus"}
                    </LocalizedLink>
                    <LocalizedLink
                      to="/villa-info"
                      className="block text-sm text-primary-600 font-medium"
                    >
                      {t("villa_info_title")}
                    </LocalizedLink>
                  </div>
                </div>

                {/* Wedding Links */}
                <div className="bg-background-50 border border-background-200 rounded-lg p-6">
                  <h3 className="font-heading text-sm text-foreground-950 mb-4 uppercase tracking-wider">
                    {t("villa_info_sidebar_weddings")}
                  </h3>
                  <div className="space-y-3">
                    <LocalizedLink
                      to="/weddings/general-wedding-information"
                      className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      {t("wedding_cat_allgemein_title")}
                    </LocalizedLink>
                  </div>
                </div>

                {/* Tour Links */}
                <div className="bg-background-50 border border-background-200 rounded-lg p-6">
                  <h3 className="font-heading text-sm text-foreground-950 mb-4 uppercase tracking-wider">
                    {t("villa_info_sidebar_tours")}
                  </h3>
                  <div className="space-y-3">
                    <LocalizedLink
                      to="/day-trips"
                      className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      {t("tour_category_daytrips_title")}
                    </LocalizedLink>
                    <LocalizedLink
                      to="/multi-day-tours"
                      className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      {t("tour_category_multiday_title")}
                    </LocalizedLink>
                    <LocalizedLink
                      to="/adventure-tours"
                      className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors"
                    >
                      {t("tour_category_adventure_title")}
                    </LocalizedLink>
                  </div>
                </div>

                {/* Contact */}
                <div className="bg-background-50 border border-background-200 rounded-lg p-6">
                  <h3 className="font-heading text-sm text-foreground-950 mb-4 uppercase tracking-wider">
                    {t("villa_info_sidebar_contact")}
                  </h3>
                  <p className="text-sm text-foreground-600 mb-4">
                    {t("villa_info_sidebar_contact_note")}
                  </p>
                  <div className="space-y-3 text-sm text-foreground-700">
                    <div className="flex items-center gap-2">
                      <i className="ri-phone-line text-accent-700"></i>
                      <span>+62 81 246 21 8000</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <i className="ri-mail-line text-accent-700"></i>
                      <span>office@balivwtour.com</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}